export default "__VITE_ASSET__LpCBVF8U__"